import { consoleHook } from './utilities/parts';
import * as wjcCore from '@mescius/wijmo';
import { datadog } from './utilities/datadog';

const init = () => {
  const consoleHookInit = () => {
    // console.log 出力制御
    //  consoleLogOutputMode に下記の文字列を設定する
    //    full | onlyDebug | otherDebug | off
    //      full:
    //        console.log を普通どおり全て出力する。
    //        何の横取りもしない
    //      onlyDebug:
    //        console.log('debug xxx...', value)というように
    //        debug という文字列が含まれるものだけ表示する
    //        ただし、debug mouse:move xxx... と debug object:moving xxx... は
    //        現場配置計画の動作時に表示されすぎるので非表示にする
    //      otherDebug1:
    //        console.log('debug xxx...', value)というように
    //        debug という文字列が含まれるものだけ表示する
    //        react-gaという表示のものも非表示にする
    //      otherDebug2:
    //        'debug mouse' 'debug object' 'selection' 'Selection'
    //        という文字が含まれているもののみ非表示にする
    //        現場配置計画の mouse 動作部分で使用するための設定
    //      offCheckSessionIFrame:
    //        トークン延長処理に関係する
    //        CheckSessionIFrame や Timer.callback の
    //        console.debug 表示を不許可にする
    //      off:
    //        console.log / info / warn / error を表示させない
    const consoleLogOutputMode = 'full';
    switch (consoleLogOutputMode) {
      case 'full':
        break;
      case 'onlyDebug':
        consoleHook.hookError();
        consoleHook.hookWarn();
        consoleHook.hookInfo();
        consoleHook.acceptLog(
          ['debug'],
          [/debug mouse:move.*/, /debug object:moving.*/]
        );
        break;
      case 'otherDebug1':
        consoleHook.acceptLog([], ['debug']);
        break;
      case 'otherDebug2':
        consoleHook.acceptLog(
          [],
          ['debug mouse:', 'debug object', 'selection', 'Selection']
        );
        break;
      case 'offDebugLogOidcClient':
        consoleHook.acceptDebug(
          [],
          [
            'CheckSessionIFrame',
            'Timer.callback',
            'Timer.init',
            'AccessTokenEvents',
            'MetadataService',
            'JsonService',
            'SessionMonitor',
            'UserManager',
            'OidcClient',
            'SigninState',
          ]
        );
        break;
      case 'off':
        consoleHook.hookError();
        consoleHook.hookWarn();
        consoleHook.hookInfo();
        consoleHook.hookLog();
        break;
      default:
        throw new Error('init.js consoleLogOutputMode is bad.');
    }
  };
  consoleHookInit();

  const env = process.env;
  wjcCore.setLicenseKey(env.REACT_APP_WIJMO_KEY);

  // DataDogの初期化
  datadog.init();
  datadog.updateUser();

  // eslint-disable-next-line no-unused-vars
  const testWindowLocation = () => {
    console.log('start testWindowLocation');
    console.log(window.location);
    // 開発中の window.location の内容確認
    // host: "localhost:3000"
    // hostname: "localhost"
    // href: "http://localhost:3000/conference/0:1/0/0/Dashboard:1/Dashboard:0"
    // origin: "http://localhost:3000"
    // pathname: "/conference/0:1/0/0/Dashboard:1/Dashboard:0"
    // port: "3000"
    // protocol: "http:"
    console.log('end testWindowLocation');
  };
  // testWindowLocation();
};
init();

export default () => {};



// WEBPACK FOOTER //
// ./src/init.js